import { render, staticRenderFns } from "./XmlUploadDialog.vue?vue&type=template&id=12120f2d&scoped=true&"
import script from "./XmlUploadDialog.vue?vue&type=script&lang=js&"
export * from "./XmlUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./XmlUploadDialog.vue?vue&type=style&index=0&id=12120f2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12120f2d",
  null
  
)

export default component.exports